module.exports = __webpack_public_path__ + "img/insights.ce863bc4.svg";